import React from 'react';
import Typography from './Typography';
import { Box } from './UI/Box';
import { FormErrorMessage } from './UI/FormErrorMessage';
import { Select } from './UI/Select/Select';
import { RQEOption } from 'src/services/prescriber';

interface SelectRQEProps {
  value: number | string;
  onChange(val: number | string): void;
  rqeList?: RQEOption[];
  error?: boolean;
  isRequired?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  onBlur?(): void;
}

function SelectRQE(props: SelectRQEProps) {
  return (
    <>
      {props.label && (
        <Box mb={'10px'}>
          <Typography model="caption" weight="bold" textTransform="uppercase">
            {props.label}
          </Typography>
        </Box>
      )}
      <Select
        h={'45px'}
        m={0}
        p={0}
        value={props.value}
        placeholder={props.placeholder}
        onChange={(e) => {
          const value = e.target.value;
          const convertedValue = value === 'Não exibir' ? value : Number(value);
          props.onChange(convertedValue);
        }}
        onBlur={props.onBlur}
        isDisabled={props.disabled}
        data-testid={'rqe-select'}
      >
        <option value={'Não exibir'}>Não exibir</option>
        {props.rqeList?.map((rqe) => {
          const valueToUse = rqe.idRqe || (rqe as any).nrRqe;
          return (
            <option value={valueToUse} key={valueToUse}>
              {rqe.descricao}
            </option>
          );
        })}
      </Select>

      <FormErrorMessage fontWeight={'bold'} textTransform={'uppercase'}>
        {props.errorMessage}
      </FormErrorMessage>
    </>
  );
}

export default SelectRQE;
